import { notification } from 'antd';

const showNotification = (type , placement, message,description) => {
notification[type]({
    message,
    description,
    placement: placement || 'topRight',
    duration: 3.5,
    className: `ifit-toast ifit-toast-${type}`,
})
}

export default showNotification
